/* Dansk katalog for locale-onboarding-setup-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'onb.companyFormRequired': 'Angiv selskabsformen fra virksomhedens registrering.',
  'home.incompleteBasisTitle': 'Regnskabsgrundlaget er ufuldstændigt',
  'home.incompleteBasisText': 'Oversigten vises ikke som komplet, fordi journaldækningen eller det nødvendige primogrundlag ikke er dokumenteret. Tilgængelige data er bevaret til kontrol.',
  'common.doLater': 'Gør senere',
  'onb.restMode.required': 'Vælg, om selskabet skal søge om hviletilstand eller bruge den almindelige løsning.',
  'onb.task.restMode.title': 'Færdiggør opsætningen af selskab i hviletilstand',
  'onb.task.restMode.detail': 'Forbind alle bankkonti, kontrollér åbningsbalancen, og giv de nødvendige fuldmagter, før automatikken kan starte.',
  'onb.task.restMode.activityDetail': 'Automatikken er stoppet, fordi Plumme har fundet aktivitet, der skal kontrolleres. Renter og almindelige bankgebyrer stopper ikke hviletilstanden.',
  'onb.task.restMode.qualificationActivityDetail': 'Kvalificeringen er sat på pause, fordi Plumme har registreret aktivitet, der skal vurderes. Automatikken er stadig sat på pause. Annullering fjerner ikke kontrolsporet.',
  'onb.task.restMode.finding.sales_activity': 'Salg er registreret.',
  'onb.task.restMode.finding.purchase_activity': 'Køb eller bilag er registreret.',
  'onb.task.restMode.finding.payroll_activity': 'Ansatte eller lønaktivitet er registreret.',
  'onb.task.restMode.finding.fixed_asset_activity': 'Anlægsaktiver er registreret.',
  'onb.task.restMode.finding.investment_activity': 'Investeringer er registreret.',
  'onb.task.restMode.finding.manual_accounting_activity': 'Manuelle regnskabsposteringer er registreret.',
  'onb.task.restMode.finding.other_bank_activity': 'Bankaktivitet ud over renter og almindelige gebyrer er registreret.',
  'onb.task.restMode.finding.unsupported_scope': 'Land eller selskabsform understøttes ikke for hviletilstand.',
  'onb.task.restMode.finding.unknown': 'Et andet kvalificeringsfund kræver vurdering.',
  'onb.vat.period': 'Hvilken momsperiode er virksomheden registreret med?',
  'onb.vat.periodHelp': 'Vælg den periode, der er registreret hos Skatteetaten.',
  'onb.vat.periodPick': 'Vælg momsperiode',
  'onb.vat.periodRequired': 'Vælg den momsperiode, virksomheden er registreret med.',
  'onb.migration.step': 'Overførsel',
  'onb.migration.title': 'Hvordan skal tallene flyttes til Plumme?',
  'onb.migration.help': 'Vælg overgangstidspunkt og metode. Selve importen kan færdiggøres, efter at virksomheden er oprettet.',
  'onb.migration.yearStart': 'Overgang 1. januar',
  'onb.migration.yearStartHelp': 'Brug den færdige saldo fra dagen før som åbningsbalance.',
  'onb.migration.midYear': 'Overgang midt i året',
  'onb.migration.midYearHelp': 'Medtag årets bevægelser, åbne poster og igangværende momsperiode frem til overgangsdatoen.',
  'onb.migration.method': 'Overførselsmetode',
  'onb.migration.methodHelp': 'Komplet import anbefales, når filen findes. Alt kontrolleres før godkendelse.',
  'onb.migration.pick': 'Vælg metode',
  'onb.migration.complete': 'Komplet import eller SAF-T (anbefalet)',
  'onb.migration.balance': 'Importér saldobalance / åbningsbalance',
  'onb.migration.manual': 'Indtast manuelt',
  'onb.migration.transitionRequired': 'Vælg, om overgangen sker 1. januar eller midt i året.',
  'onb.migration.methodRequired': 'Vælg, hvordan regnskabet skal overføres, eller gør det senere.',
  'onb.bank.step': 'Bankkonti',
  'onb.bank.title': 'Opsæt virksomhedens bankkonti',
  'onb.bank.help': 'Bankkontiene bruges til betaling, fakturaer og afstemning. Bankintegration er et separat tilvalg og indgår ikke i denne opsætning.',
  'onb.bank.addNow': 'Tilføj bankkonti nu',
  'onb.bank.addNowHelp': 'Registrér konto, startsaldo og eventuelle kort.',
  'onb.bank.none': 'Ingen separat erhvervskonto',
  'onb.bank.noneHelp': 'Passer, når virksomhedens køb betales privat og skal registreres som udlæg.',
  'onb.bank.laterHelp': 'Opgaven bliver liggende under Næste trin.',
  'onb.bank.invoiceDefault': 'Brug denne konto på fakturaer',
  'onb.bank.cardsLater': 'Afklar kort senere',
  'onb.bank.addAnother': 'Tilføj en bankkonto',
  'onb.bank.noConnection': 'Bankforbindelse er fjernet fra grundopsætningen. En eventuel bankintegration tilbydes separat som et betalt tilvalg.',
  'onb.bank.choiceRequired': 'Vælg, om bankkonti skal opsættes nu eller senere.',
  'onb.bank.accountRequired': 'Tilføj mindst én bankkonto.',
  'onb.bank.incomplete': 'Udfyld kontonummer, hovedbogskonto, startdato og startsaldo for alle bankkonti.',
  'onb.bank.cardRequired': 'Angiv kortets sidste fire cifre, bekræft, at kontoen ikke har kort, eller afklar kort senere.',
  'onb.bank.accountName': 'Kontoens navn',
  'onb.bank.account': 'Bankkonto',
  'onb.bank.ledger': 'Konto i regnskabet',
  'onb.bank.startDate': 'Startdato',
  'onb.bank.startBalance': 'Saldo på startdato',
  'onb.invoice.step': 'Fakturaopsætning',
  'onb.invoice.title': 'Gør faktureringen klar',
  'onb.invoice.help': 'Næste fakturanummer skal videreføre en kontrollerbar nummerrække. Ved import bør nummeret kontrolleres mod tidligere fakturaer.',
  'onb.invoice.now': 'Opsæt faktura nu',
  'onb.invoice.nowHelp': 'Vælg næste fakturanummer og almindelig betalingsfrist.',
  'onb.invoice.laterHelp': 'Opsætningen skal færdiggøres, før den første faktura kan udstedes.',
  'onb.invoice.choiceRequired': 'Vælg, om fakturaopsætningen skal ske nu eller senere.',
  'onb.invoice.invalid': 'Næste fakturanummer skal være mindst 1, og betalingsfristen mellem 1 og 365 dage.',
  'onb.invoice.paymentDays': 'Almindelig betalingsfrist (dage)',
  'onb.vehicle.step': 'Køretøj',
  'onb.vehicle.title': 'Har virksomheden køretøjer eller bilomkostninger?',
  'onb.vehicle.help': 'Svaret bruges til at følge op på den rigtige køretøjsopsætning. Det afgør ikke alene momsfradraget.',
  'onb.vehicle.business': 'Virksomheden ejer eller leaser',
  'onb.vehicle.businessHelp': 'Køretøjstype, brug og fradragsbehandling afklares i en separat opsætning.',
  'onb.vehicle.private': 'Privat køretøj bruges i virksomheden',
  'onb.vehicle.privateHelp': 'Plumme følger op på kørebog og private udlæg.',
  'onb.vehicle.noneHelp': 'Der oprettes ingen køretøjsopfølgning nu.',
  'onb.vehicle.laterHelp': 'Opgaven vises igen efter behov.',
  'onb.vehicle.choiceRequired': 'Vælg, hvordan køretøjer skal følges op, eller gør det senere.',
  'onb.review.step': 'Opsummering',
  'onb.review.title': 'Kontrollér opsætningen',
  'onb.review.deferredHelp': 'Virksomheden kan oprettes nu. Det, du har udsat, forbliver synligt under Næste trin.',
  'onb.review.readyHelp': 'Grundopsætningen er klar. Du kan ændre oplysningerne senere i Indstillinger.',
  'onb.followup.migration': 'Færdiggør overførsel fra tidligere system',
  'onb.followup.bank': 'Opsæt bankkonti',
  'onb.followup.invoice': 'Færdiggør fakturaopsætningen',
  'onb.followup.vehicle': 'Afklar køretøjsopsætningen',
  'onb.task.eyebrow': 'Kom i gang',
  'onb.task.title': 'Næste trin for virksomheden',
  'onb.task.help': 'Opgaverne forsvinder automatisk, når opsætningen er færdig. Visse opgaver kan du også selv markere som udført. Påkrævet kvalificering skal bekræftes af systemet.',
  'onb.task.remaining': '{{count}} opgaver mangler',
  'onb.task.open': 'Åbn',
  'onb.task.complete': 'Udført',
  'onb.task.completeError': 'Opgaven kunne ikke markeres som udført.',
  'onb.task.showAll': 'Vis alle ({{count}})',
  'onb.task.showLess': 'Vis færre',
  'onb.task.vat.title': 'Vælg registreret momsperiode',
  'onb.task.vat.detail': 'Frister og MVA-meldinger kan ikke planlægges sikkert, før perioden er bekræftet.',
  'onb.task.migration.title': 'Færdiggør overførsel fra tidligere system',
  'onb.task.migration.detail': 'Importér SAF-T, saldobalance eller starttal, og kontrollér grundlaget.',
  'onb.task.bank.title': 'Opsæt bankkonti',
  'onb.task.bank.detail': 'Registrér startdato, startsaldo og eventuelle kort før bankafstemning.',
  'onb.task.invoice.title': 'Fuldfør fakturaopsætningen',
  'onb.task.invoice.detail': 'Kontrollér næste fakturanummer og betalingsfrist før den første faktura.',
  'onb.task.vehicle.title': 'Afklar køretøjsopsætningen',
  'onb.task.vehicle.detail': 'Vælg den rigtige opfølgning, før køretøjsudgifter behandles automatisk.',
  'onb.task.master.title': 'Importér kunder, leverandører og produkter',
  'onb.task.master.detail': 'Gør dette efter en komplet regnskabsimport, så du undgår dubletter.',
  'onb.doneAlt': 'Plumme',
  'onb.bank.operatingName': 'Driftskonto',
  'onb.bank.currency': 'Valuta',
  'onb.assets.step': 'Aktiver',
  'onb.assets.title': 'Er der aktiver i åbningsbalancen?',
  'onb.assets.help': 'Maskiner, inventar, biler og andre varige driftsmidler skal registreres enkeltvis, efter at indgående balance eller import er på plads.',
  'onb.assets.yes': 'Ja, registrér efter overførslen',
  'onb.assets.yesHelp': 'Plumme opretter en opgave og åbner den eksisterende registrering fra åbningsbalancen.',
  'onb.assets.noHelp': 'Ingen aktiver skal videreføres fra tidligere regnskab.',
  'onb.assets.laterHelp': 'Afklar dette, når overførslen er kontrolleret.',
  'onb.assets.separateValues': 'Plumme opretter ikke aktiver ud fra en samlet kontosaldo. Dokumentér bogført værdi, skattemæssig værdi og afskrivningsplan separat.',
  'onb.assets.choiceRequired': 'Vælg, om åbningsbalancen indeholder aktiver, eller gør det senere.',
  'onb.followup.assets': 'Registrér aktiver fra åbningsbalancen',
  'onb.task.assets.title': 'Registrér aktiver fra åbningsbalancen',
  'onb.task.assets.detail': 'Opret ét dokumenteret aktiv ad gangen, og afstem totalen mod kontiene i indgående balance.',
});
